<p>
  <b>RPP - Registered Pension Plan -</b> Once you stop working, or retire from NWMO, your pension increases
  each January 1st at 100% of the Ontario Consumer Price Index (CPI), up to 8%. 
  The illustrations shown here do not include indexation.
</p>
